var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14.5","cy":"14.5","r":"13.5","fill":"#EFF1FF","stroke":"#40196D","strokeWidth":"0.5","key":0}),React.createElement("path",{"d":"M8 8.52593H11.6865L15.094 13.1094L19.3355 8.4209L20.3433 8.4384L15.5964 13.7688L20.4645 20.3159H16.7795L13.5633 16.0445L9.63438 20.4209H8.64265L13.0755 15.4202L8 8.52593ZM11.3389 9.20281H9.39192L17.1811 19.6215H19.093L11.3389 9.20281Z","fill":"#40196D","key":1})]);
}

TwitterInline.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
